import { RouteConfig } from 'vue-router';

import { AttachmentType } from '@/enums/attachmentType.enum';
import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export function procedureAttachmentsRoute(name: string): RouteConfig {
  return {
    path: 'attachments',
    name,
    component: () =>
      import(/* webpackChunkName: "ProcedureAttachment" */ '@/views/mainRoute/procedure/steps/Attachments.vue'),
    meta: {},
    beforeEnter(to, from, next) {
      store
        .dispatch('procedure/attachment/list', {
          order: 'order',
          desc: false,
          count: -1,
          entityType: EntityType.PROCEDURE,
          entityId: to.params.procedureId.toString(),
          type: AttachmentType.UPLOADED
        })
        .then(() => next())
        .catch(err => store.dispatch('notifyError', { title: Errors.ATTACHMENT_CANNOT_LIST }));
    }
  };
}
